import { LandingPage } from '../types'
import { AVA_FORM } from './avaForm'

export const AVA_VIDEO_THUMBNAIL =
  'https://cdn.magicpatterns.com/patterns/generated-images/bc84f3af-f91f-4ad3-b568-f3c34b103930.jpg'

export const AVA_LANDING: LandingPage = {
  id: 'landing_ava',
  organizationId: 'org_ava',
  formId: AVA_FORM.id,
  name: 'Landing principal Sistema AVA',
  slug: 'sistema-ava',
  status: 'publicada',
  views: 8421,
  createdAt: '2026-05-02T09:00:00.000Z',
  updatedAt: '2026-07-28T16:10:00.000Z',
  pageConfig: {
    theme: 'blanco_premium',
    primaryColor: '#3D8BFF',
    fontFamily: 'Inter',
    blocks: [
      {
        id: 'b_topbar',
        type: 'topbar',
        visible: true,
        spacing: 'normal',
        config: { ctaLabel: 'Quiero implementar AVA', sticky: true },
      },
      {
        id: 'b_hero',
        type: 'hero',
        visible: true,
        spacing: 'amplio',
        config: {
          showLogo: false,
          eyebrow: 'Sistema AVA',
          title:
            'Conseguimos clientes cualificados todos los meses para tu empresa.',
          highlight: 'clientes cualificados|todos los meses',
          subtitle:
            'Mediante contenido viral, campañas de publicidad y automatización con inteligencia artificial.',
          extraLine: '',
        },
      },
      {
        id: 'b_video',
        type: 'video',
        visible: true,
        spacing: 'normal',
        config: {
          url: '',
          thumbnailUrl: AVA_VIDEO_THUMBNAIL,
          note: 'Descubre cómo funciona el Sistema AVA',
          caption: '',
          ctaLabel: 'QUIERO IMPLEMENTAR AVA EN MI EMPRESA',
        },
      },
      {
        id: 'b_beneficios',
        type: 'beneficios',
        visible: true,
        spacing: 'amplio',
        config: {
          title: 'Un sistema completo de captación',
          items: [
            {
              icon: 'Target',
              title: 'Clientes cualificados',
              text: 'Generamos nuevas oportunidades comerciales para tu empresa mediante un sistema medible.',
            },
            {
              icon: 'Video',
              title: 'Contenido viral',
              text: 'Creamos vídeos diseñados para captar la atención del cliente adecuado.',
            },
            {
              icon: 'Megaphone',
              title: 'Campañas de publicidad',
              text: 'Convertimos el contenido y la oferta en campañas orientadas a generar contactos.',
            },
            {
              icon: 'Sparkles',
              title: 'Automatización con IA',
              text: 'Automatizamos la recepción, organización y seguimiento inicial de los potenciales clientes.',
            },
          ],
        },
      },
      {
        id: 'b_formulario',
        type: 'formulario',
        visible: true,
        spacing: 'amplio',
        config: {
          title: 'Solicita tu estrategia AVA',
          subtitle:
            'Responde unas preguntas rápidas sobre tu empresa y preparamos una propuesta a medida.',
        },
      },
      {
        id: 'b_testimonios',
        type: 'testimonios',
        visible: true,
        spacing: 'amplio',
        config: {
          title: 'Empresas que ya trabajan con el Sistema AVA',
          items: [
            {
              name: 'Marta Ruiz',
              role: 'Directora comercial',
              company: 'Nova Inmobiliaria',
              result: '+38 visitas al mes',
              text: 'Pasamos de depender de recomendaciones a tener una agenda de visitas constante cada semana.',
              avatar:
                'https://cdn.magicpatterns.com/patterns/generated-images/c9c10598-2a3f-4a05-bc96-090f76487166.jpg',
            },
            {
              name: 'Javier Soler',
              role: 'Fundador',
              company: 'Cocinas Soler',
              result: '0 contactos perdidos',
              text: 'Los vídeos nos trajeron atención y el CRM nos ayudó a no perder ni un solo contacto.',
              avatar:
                'https://cdn.magicpatterns.com/patterns/generated-images/df8aaaae-c331-42ef-b014-bed123f7c5d7.jpg',
            },
            {
              name: 'Diego Márquez',
              role: 'CEO',
              company: 'Clínica Vitalis',
              result: 'Respuesta en 5 minutos',
              text: 'La automatización responde en minutos. Antes tardábamos días en contactar con un paciente.',
              avatar:
                'https://cdn.magicpatterns.com/patterns/generated-images/3a633f31-da2f-4884-a36f-441a3f921775.jpg',
            },
          ],
        },
      },
      {
        id: 'b_faq',
        type: 'faq',
        visible: true,
        spacing: 'amplio',
        config: {
          title: 'Preguntas frecuentes',
          items: [
            {
              q: '¿En cuánto tiempo se ven resultados?',
              a: 'Las primeras campañas suelen generar contactos durante las dos primeras semanas. La parte de contenido consolida los resultados a partir del segundo mes.',
            },
            {
              q: '¿Necesito aparecer en los vídeos?',
              a: 'No es obligatorio. Trabajamos con distintos formatos: portavoz, equipo, producto o formatos sin rostro.',
            },
            {
              q: '¿Qué incluye la automatización?',
              a: 'Recepción del contacto, alta automática en tu CRM, respuesta inicial y recordatorios de seguimiento para tu equipo.',
            },
            {
              q: '¿Puedo usar mi propio CRM?',
              a: 'Sí. AVA incluye su propio CRM, y además puede enviar los leads a otras herramientas mediante webhooks.',
            },
          ],
        },
      },
      {
        id: 'b_footer',
        type: 'footer',
        visible: true,
        spacing: 'normal',
        config: {
          text: '© 2026 Sistema AVA. Atracción, Viralidad y Automatización.',
          links: ['Política de privacidad', 'Aviso legal', 'Cookies'],
        },
      },
    ],
    thankYou: {
      title: 'Hemos recibido tu solicitud.',
      text: 'Nuestro equipo revisará la información de tu empresa y se pondrá en contacto contigo para explicarte cómo podríamos implementar el Sistema AVA.',
      showCalendly: true,
      calendlyUrl: '',
      showWhatsapp: true,
      whatsappNumber: '',
      showHome: true,
    },
  },
}
